import {useState} from "react";
import {useQuery} from "react-query";
import {useHistory} from "react-router-dom";
import {
  DropdownSelect,
  DropdownSelectText,
  ThinScrollbarArea,
} from "@reside/ui";
import {RoleNameEnum} from "../../utils/types/common";

import {AdminRoles} from "../../atoms/admin-roles";
import {AdminLayoutFullHeightAndTwoCells} from "../../atoms/admin-layout";
import {DocumentTitle} from "../../atoms/document-title";
import {Spinner} from "../../atoms/spinner";
import {AdminOrganizationsSearch} from "../../atoms/admin-search";
import {OrganizationsService} from "../../services/OrganizationsService";
import {ButtonLink} from "../../atoms/button-link";
import {AdminOrganizationsTable} from "../../atoms/admin-table";
import {logErrorToSentry} from "../../utils/sentry";
import {AdminActionRow} from "../../atoms/admin-action-row";

const STATUSES = [
  {id: null, label: "All"},
  {id: "ACTIVE", label: "Active"},
  {id: "INACTIVE", label: "Inactive"},
];

export const PageAdminOrganizations = () => {
  const history = useHistory();
  const [status, setStatus] = useState(STATUSES[0]);

  const {data, isLoading} = useQuery(
    ["getOrganizations", status],
    async () => {
      const {data} = await OrganizationsService.get({
        size: 999,
        sort: "name,asc",
        status: status.id,
      });

      return data.content;
    },
    {
      onError: (err: any) => {
        logErrorToSentry(err, {
          STATUSES,
          history,
          status,
          data,
          isLoading,
        });
      },
    },
  );

  return (
    <AdminLayoutFullHeightAndTwoCells>
      <DocumentTitle title="Reside - Admin - Organizations" />
      <AdminActionRow
        filter={
          <DropdownSelect
            trigger={({isOpened}) => (
              <DropdownSelectText isOpened={isOpened} label={status.label} />
            )}
            selectItem={setStatus}
            selectedItem={status}
            items={STATUSES}
            label="Status"
          />
        }
        actions={
          <AdminRoles roles={[RoleNameEnum.RESIDE_ADMIN]}>
            <ButtonLink
              outline={false}
              to="/admin/organizations/create"
              testId="addOrganizationButton"
              color="primary"
            >
              New Organization
            </ButtonLink>
          </AdminRoles>
        }
        search={
          <AdminRoles roles={[RoleNameEnum.RESIDE_ADMIN]}>
            <AdminOrganizationsSearch />
          </AdminRoles>
        }
        withCreateNewAdmissionButton={false}
      />

      <ThinScrollbarArea>
        {isLoading ? (
          <Spinner />
        ) : (
          <AdminOrganizationsTable
            tableName="organizations"
            organizations={data}
            onRowClick={(id: string) =>
              history.push(`/admin/organizations/${id}/edit`)
            }
          />
        )}
      </ThinScrollbarArea>
    </AdminLayoutFullHeightAndTwoCells>
  );
};
